import { defineDomainTranslations } from './defineDomainTranslations';

export const GUEST_TRIAL_TRANSLATIONS = defineDomainTranslations({
  en: {
    'guestTrial.backToOffer': 'Back to the offer',
    'guestTrial.checkoutError': 'We couldn’t open checkout. Please try again.',
    'guestTrial.demoHeadline': 'See AI dubbing in action',
    'guestTrial.includes': '{days} days · {minutes} dubbing minutes · All premium features',
    'guestTrial.metaTitle': 'Try Rask',
    'guestTrial.offerUnavailable': 'This offer isn’t available right now. Please try again later.',
    'guestTrial.payment.accountExists': 'You already have a Rask account with this email.',
    'guestTrial.payment.cardError': 'The payment didn’t go through. Check your details and try again.',
    'guestTrial.payment.contactInformation': 'Contact',
    'guestTrial.payment.daysFree': '{days} days free',
    'guestTrial.payment.details': 'Details',
    'guestTrial.payment.email': 'Email',
    'guestTrial.payment.emailRequired': 'Enter your email to pay by card.',
    'guestTrial.payment.headline': 'Rask trial',
    'guestTrial.payment.loadError': 'We couldn’t load the payment form. Please try again.',
    'guestTrial.payment.logInToChoosePlan': 'Log in to choose a plan.',
    'guestTrial.payment.or': 'OR',
    'guestTrial.payment.payAndStartTrial': 'Pay and start trial',
    'guestTrial.payment.paymentMethod': 'Payment method',
    'guestTrial.payment.perMonthAfter': '{amount} / month after trial',
    'guestTrial.payment.poweredBy': 'Powered by',
    'guestTrial.payment.privacy': 'Privacy',
    'guestTrial.payment.purchasingAsBusiness': 'I’m purchasing as a business',
    'guestTrial.payment.sandbox': 'Sandbox',
    'guestTrial.payment.subtotal': 'Subtotal',
    'guestTrial.payment.tax': 'Tax',
    'guestTrial.payment.taxInfo': '{tax} is calculated based on your location and product details.',
    'guestTrial.payment.taxPending': 'Calculated from your address',
    'guestTrial.payment.terms': 'Terms',
    'guestTrial.payment.thenPerMonth': 'Then {amount} per month',
    'guestTrial.payment.totalDueToday': 'Total due today',
    'guestTrial.payment.viewDetails': 'View details',
    'guestTrial.renewal': 'Then the Creator plan at {renewalPrice}/month unless canceled',
    'guestTrial.soundHint': 'Turn on sound to hear the difference',
    'guestTrial.startNow': 'Start now for {price}',
    'guestTrial.success.checking': 'Confirming your payment…',
    'guestTrial.success.claimed': 'This payment is already linked to a Rask account.',
    'guestTrial.success.createAccount': 'Create account',
    'guestTrial.success.email':
      'Sign up with {email} to link this payment. We also emailed you a link to finish signing up on any device.',
    'guestTrial.success.noClaim':
      'We couldn’t find your payment on this device. Open this page on the device and browser you paid with.',
    'guestTrial.success.openApp': 'Open Rask',
    'guestTrial.success.paid': 'Payment received — create your account to start your trial',
    'guestTrial.success.pending': 'We’re still confirming your payment. This can take a minute.',
    'guestTrial.success.retry': 'Check again',
  },
  es: {
    'guestTrial.backToOffer': 'Volver a la oferta',
    'guestTrial.checkoutError': 'No pudimos abrir la página de pago. Inténtalo de nuevo.',
    'guestTrial.demoHeadline': 'Mira el doblaje con IA en acción',
    'guestTrial.includes': '{days} días · {minutes} minutos de doblaje · Todas las funciones premium',
    'guestTrial.metaTitle': 'Prueba Rask',
    'guestTrial.offerUnavailable': 'Esta oferta no está disponible en este momento. Inténtalo más tarde.',
    'guestTrial.payment.accountExists': 'Ya tienes una cuenta de Rask con este correo electrónico.',
    'guestTrial.payment.cardError': 'No se pudo completar el pago. Revisa tus datos e inténtalo de nuevo.',
    'guestTrial.payment.contactInformation': 'Contacto',
    'guestTrial.payment.daysFree': '{days} días gratis',
    'guestTrial.payment.details': 'Detalles',
    'guestTrial.payment.email': 'Correo electrónico',
    'guestTrial.payment.emailRequired': 'Introduce tu correo electrónico para pagar con tarjeta.',
    'guestTrial.payment.headline': 'Prueba de Rask',
    'guestTrial.payment.loadError': 'No pudimos cargar el formulario de pago. Inténtalo de nuevo.',
    'guestTrial.payment.logInToChoosePlan': 'Inicia sesión para elegir un plan.',
    'guestTrial.payment.or': 'O',
    'guestTrial.payment.payAndStartTrial': 'Pagar y empezar la prueba',
    'guestTrial.payment.paymentMethod': 'Método de pago',
    'guestTrial.payment.perMonthAfter': '{amount} al mes tras la prueba',
    'guestTrial.payment.poweredBy': 'Con la tecnología de',
    'guestTrial.payment.privacy': 'Privacidad',
    'guestTrial.payment.purchasingAsBusiness': 'Compro como empresa',
    'guestTrial.payment.sandbox': 'Entorno de pruebas',
    'guestTrial.payment.subtotal': 'Subtotal',
    'guestTrial.payment.tax': 'Impuestos',
    'guestTrial.payment.taxInfo': 'El cálculo de {tax} se basa en tu ubicación y en los detalles del producto.',
    'guestTrial.payment.taxPending': 'Se calcula según tu dirección',
    'guestTrial.payment.terms': 'Términos',
    'guestTrial.payment.thenPerMonth': 'Después, {amount} al mes',
    'guestTrial.payment.totalDueToday': 'Total a pagar hoy',
    'guestTrial.payment.viewDetails': 'Ver detalles',
    'guestTrial.renewal': 'Después, el plan Creator por {renewalPrice}/mes salvo que canceles',
    'guestTrial.soundHint': 'Activa el sonido para notar la diferencia',
    'guestTrial.startNow': 'Empieza ahora por {price}',
    'guestTrial.success.checking': 'Confirmando tu pago…',
    'guestTrial.success.claimed': 'Este pago ya está vinculado a una cuenta de Rask.',
    'guestTrial.success.createAccount': 'Crear cuenta',
    'guestTrial.success.email':
      'Regístrate con {email} para vincular este pago. También te enviamos un enlace por correo para terminar el registro desde cualquier dispositivo.',
    'guestTrial.success.noClaim':
      'No encontramos los datos de tu compra en este dispositivo. Abre esta página en el dispositivo y el navegador con los que pagaste.',
    'guestTrial.success.openApp': 'Abrir Rask',
    'guestTrial.success.paid': 'Pago recibido: crea tu cuenta para empezar tu prueba',
    'guestTrial.success.pending': 'Seguimos confirmando tu pago. Puede tardar un minuto.',
    'guestTrial.success.retry': 'Comprobar de nuevo',
  },
  fr: {
    'guestTrial.backToOffer': 'Retour à l’offre',
    'guestTrial.checkoutError': 'Impossible d’ouvrir la page de paiement. Veuillez réessayer.',
    'guestTrial.demoHeadline': 'Découvrez le doublage IA en action',
    'guestTrial.includes': '{days} jours · {minutes} minutes de doublage · Toutes les fonctionnalités premium',
    'guestTrial.metaTitle': 'Essayez Rask',
    'guestTrial.offerUnavailable': 'Cette offre n’est pas disponible pour le moment. Veuillez réessayer plus tard.',
    'guestTrial.payment.accountExists': 'Vous avez déjà un compte Rask avec cet e-mail.',
    'guestTrial.payment.cardError': 'Le paiement n’a pas abouti. Vérifiez vos informations et réessayez.',
    'guestTrial.payment.contactInformation': 'Contact',
    'guestTrial.payment.daysFree': '{days} jours gratuits',
    'guestTrial.payment.details': 'Détails',
    'guestTrial.payment.email': 'E-mail',
    'guestTrial.payment.emailRequired': 'Saisissez votre e-mail pour payer par carte.',
    'guestTrial.payment.headline': 'Essai Rask',
    'guestTrial.payment.loadError': 'Impossible de charger le formulaire de paiement. Veuillez réessayer.',
    'guestTrial.payment.logInToChoosePlan': 'Connectez-vous pour choisir un forfait.',
    'guestTrial.payment.or': 'OU',
    'guestTrial.payment.payAndStartTrial': 'Payer et commencer l’essai',
    'guestTrial.payment.paymentMethod': 'Moyen de paiement',
    'guestTrial.payment.perMonthAfter': '{amount} par mois après l’essai',
    'guestTrial.payment.poweredBy': 'Propulsé par',
    'guestTrial.payment.privacy': 'Confidentialité',
    'guestTrial.payment.purchasingAsBusiness': 'J’achète en tant qu’entreprise',
    'guestTrial.payment.sandbox': 'Environnement de test',
    'guestTrial.payment.subtotal': 'Sous-total',
    'guestTrial.payment.tax': 'Taxes',
    'guestTrial.payment.taxInfo': 'Le montant de {tax} est calculé en fonction de votre adresse et des détails du produit.',
    'guestTrial.payment.taxPending': 'Calculées selon votre adresse',
    'guestTrial.payment.terms': 'Conditions',
    'guestTrial.payment.thenPerMonth': 'Puis {amount} par mois',
    'guestTrial.payment.totalDueToday': 'Total dû aujourd’hui',
    'guestTrial.payment.viewDetails': 'Voir les détails',
    'guestTrial.renewal': 'Puis le forfait Creator à {renewalPrice}/mois, sauf annulation',
    'guestTrial.soundHint': 'Activez le son pour entendre la différence',
    'guestTrial.startNow': 'Commencez maintenant pour {price}',
    'guestTrial.success.checking': 'Confirmation de votre paiement…',
    'guestTrial.success.claimed': 'Ce paiement est déjà associé à un compte Rask.',
    'guestTrial.success.createAccount': 'Créer un compte',
    'guestTrial.success.email':
      'Inscrivez-vous avec {email} pour associer ce paiement. Nous vous avons aussi envoyé un lien par e-mail pour terminer l’inscription sur n’importe quel appareil.',
    'guestTrial.success.noClaim':
      'Nous ne trouvons pas les informations de votre paiement sur cet appareil. Ouvrez cette page sur l’appareil et le navigateur utilisés pour payer.',
    'guestTrial.success.openApp': 'Ouvrir Rask',
    'guestTrial.success.paid': 'Paiement reçu : créez votre compte pour démarrer votre essai',
    'guestTrial.success.pending': 'Votre paiement est toujours en cours de confirmation. Cela peut prendre une minute.',
    'guestTrial.success.retry': 'Vérifier à nouveau',
  },
  it: {
    'guestTrial.backToOffer': 'Torna all’offerta',
    'guestTrial.checkoutError': 'Impossibile aprire il pagamento. Riprova.',
    'guestTrial.demoHeadline': 'Guarda il doppiaggio IA in azione',
    'guestTrial.includes': '{days} giorni · {minutes} minuti di doppiaggio · Tutte le funzioni premium',
    'guestTrial.metaTitle': 'Prova Rask',
    'guestTrial.offerUnavailable': 'Questa offerta non è disponibile al momento. Riprova più tardi.',
    'guestTrial.payment.accountExists': 'Hai già un account Rask con questa email.',
    'guestTrial.payment.cardError': 'Il pagamento non è andato a buon fine. Controlla i dati e riprova.',
    'guestTrial.payment.contactInformation': 'Contatto',
    'guestTrial.payment.daysFree': '{days} giorni gratis',
    'guestTrial.payment.details': 'Dettagli',
    'guestTrial.payment.email': 'Email',
    'guestTrial.payment.emailRequired': 'Inserisci la tua email per pagare con carta.',
    'guestTrial.payment.headline': 'Prova di Rask',
    'guestTrial.payment.loadError': 'Impossibile caricare il modulo di pagamento. Riprova.',
    'guestTrial.payment.logInToChoosePlan': 'Accedi per scegliere un piano.',
    'guestTrial.payment.or': 'OPPURE',
    'guestTrial.payment.payAndStartTrial': 'Paga e inizia la prova',
    'guestTrial.payment.paymentMethod': 'Metodo di pagamento',
    'guestTrial.payment.perMonthAfter': '{amount} al mese dopo la prova',
    'guestTrial.payment.poweredBy': 'Con tecnologia di',
    'guestTrial.payment.privacy': 'Privacy',
    'guestTrial.payment.purchasingAsBusiness': 'Acquisto come azienda',
    'guestTrial.payment.sandbox': 'Ambiente di test',
    'guestTrial.payment.subtotal': 'Subtotale',
    'guestTrial.payment.tax': 'Imposte',
    'guestTrial.payment.taxInfo': 'L’importo di {tax} è calcolato in base alla tua posizione e ai dettagli del prodotto.',
    'guestTrial.payment.taxPending': 'Calcolate in base al tuo indirizzo',
    'guestTrial.payment.terms': 'Termini',
    'guestTrial.payment.thenPerMonth': 'Poi {amount} al mese',
    'guestTrial.payment.totalDueToday': 'Totale dovuto oggi',
    'guestTrial.payment.viewDetails': 'Visualizza dettagli',
    'guestTrial.renewal': 'Poi il piano Creator a {renewalPrice}/mese, salvo disdetta',
    'guestTrial.soundHint': 'Attiva l’audio per sentire la differenza',
    'guestTrial.startNow': 'Inizia ora a {price}',
    'guestTrial.success.checking': 'Conferma del pagamento in corso…',
    'guestTrial.success.claimed': 'Questo pagamento è già collegato a un account Rask.',
    'guestTrial.success.createAccount': 'Crea account',
    'guestTrial.success.email':
      'Registrati con {email} per collegare questo pagamento. Ti abbiamo anche inviato via email un link per completare la registrazione da qualsiasi dispositivo.',
    'guestTrial.success.noClaim':
      'Non troviamo il tuo pagamento su questo dispositivo. Apri questa pagina sul dispositivo e sul browser usati per pagare.',
    'guestTrial.success.openApp': 'Apri Rask',
    'guestTrial.success.paid': 'Pagamento ricevuto: crea il tuo account per iniziare la prova',
    'guestTrial.success.pending': 'Stiamo ancora confermando il pagamento. Potrebbe volerci un minuto.',
    'guestTrial.success.retry': 'Controlla di nuovo',
  },
  pt: {
    'guestTrial.backToOffer': 'Voltar para a oferta',
    'guestTrial.checkoutError': 'Não foi possível abrir a página de pagamento. Tente novamente.',
    'guestTrial.demoHeadline': 'Veja a dublagem com IA em ação',
    'guestTrial.includes': '{days} dias · {minutes} minutos de dublagem · Todos os recursos premium',
    'guestTrial.metaTitle': 'Experimente o Rask',
    'guestTrial.offerUnavailable': 'Esta oferta não está disponível no momento. Tente novamente mais tarde.',
    'guestTrial.payment.accountExists': 'Você já tem uma conta Rask com este e-mail.',
    'guestTrial.payment.cardError': 'O pagamento não foi concluído. Verifique seus dados e tente novamente.',
    'guestTrial.payment.contactInformation': 'Contato',
    'guestTrial.payment.daysFree': '{days} dias grátis',
    'guestTrial.payment.details': 'Detalhes',
    'guestTrial.payment.email': 'E-mail',
    'guestTrial.payment.emailRequired': 'Digite seu e-mail para pagar com cartão.',
    'guestTrial.payment.headline': 'Período de teste do Rask',
    'guestTrial.payment.loadError': 'Não foi possível carregar o formulário de pagamento. Tente novamente.',
    'guestTrial.payment.logInToChoosePlan': 'Faça login para escolher um plano.',
    'guestTrial.payment.or': 'OU',
    'guestTrial.payment.payAndStartTrial': 'Pagar e iniciar o teste',
    'guestTrial.payment.paymentMethod': 'Forma de pagamento',
    'guestTrial.payment.perMonthAfter': '{amount} por mês após o teste',
    'guestTrial.payment.poweredBy': 'Com tecnologia da',
    'guestTrial.payment.privacy': 'Privacidade',
    'guestTrial.payment.purchasingAsBusiness': 'Estou comprando como empresa',
    'guestTrial.payment.sandbox': 'Ambiente de testes',
    'guestTrial.payment.subtotal': 'Subtotal',
    'guestTrial.payment.tax': 'Impostos',
    'guestTrial.payment.taxInfo': 'O valor de {tax} é calculado com base na sua localização e nos detalhes do produto.',
    'guestTrial.payment.taxPending': 'Calculados com base no seu endereço',
    'guestTrial.payment.terms': 'Termos',
    'guestTrial.payment.thenPerMonth': 'Depois, {amount} por mês',
    'guestTrial.payment.totalDueToday': 'Total a pagar hoje',
    'guestTrial.payment.viewDetails': 'Ver detalhes',
    'guestTrial.renewal': 'Depois, o plano Creator por {renewalPrice}/mês, a menos que você cancele',
    'guestTrial.soundHint': 'Ative o som para ouvir a diferença',
    'guestTrial.startNow': 'Comece agora por {price}',
    'guestTrial.success.checking': 'Confirmando seu pagamento…',
    'guestTrial.success.claimed': 'Este pagamento já está vinculado a uma conta Rask.',
    'guestTrial.success.createAccount': 'Criar conta',
    'guestTrial.success.email':
      'Cadastre-se com {email} para vincular este pagamento. Também enviamos por e-mail um link para concluir o cadastro em qualquer dispositivo.',
    'guestTrial.success.noClaim':
      'Não encontramos os dados do seu pagamento neste dispositivo. Abra esta página no dispositivo e no navegador usados para pagar.',
    'guestTrial.success.openApp': 'Abrir o Rask',
    'guestTrial.success.paid': 'Pagamento recebido: crie sua conta para iniciar seu período de teste',
    'guestTrial.success.pending': 'Ainda estamos confirmando seu pagamento. Isso pode levar um minuto.',
    'guestTrial.success.retry': 'Verificar novamente',
  },
  ru: {
    'guestTrial.backToOffer': 'Вернуться к предложению',
    'guestTrial.checkoutError': 'Не удалось открыть страницу оплаты. Попробуйте ещё раз.',
    'guestTrial.demoHeadline': 'Посмотрите ИИ-дубляж в действии',
    'guestTrial.includes': '{days} дн. · {minutes} мин. дубляжа · Все премиум-функции',
    'guestTrial.metaTitle': 'Попробуйте Rask',
    'guestTrial.offerUnavailable': 'Это предложение сейчас недоступно. Попробуйте позже.',
    'guestTrial.payment.accountExists': 'У вас уже есть аккаунт Rask с этим адресом электронной почты.',
    'guestTrial.payment.cardError': 'Платёж не прошёл. Проверьте данные и попробуйте ещё раз.',
    'guestTrial.payment.contactInformation': 'Контакты',
    'guestTrial.payment.daysFree': 'Бесплатно: {days} дн.',
    'guestTrial.payment.details': 'Подробнее',
    'guestTrial.payment.email': 'Электронная почта',
    'guestTrial.payment.emailRequired': 'Введите электронную почту, чтобы оплатить картой.',
    'guestTrial.payment.headline': 'Пробный период Rask',
    'guestTrial.payment.loadError': 'Не удалось загрузить форму оплаты. Попробуйте ещё раз.',
    'guestTrial.payment.logInToChoosePlan': 'Войдите, чтобы выбрать тариф.',
    'guestTrial.payment.or': 'ИЛИ',
    'guestTrial.payment.payAndStartTrial': 'Оплатить и начать пробный период',
    'guestTrial.payment.paymentMethod': 'Способ оплаты',
    'guestTrial.payment.perMonthAfter': '{amount} в месяц после пробного периода',
    'guestTrial.payment.poweredBy': 'На платформе',
    'guestTrial.payment.privacy': 'Конфиденциальность',
    'guestTrial.payment.purchasingAsBusiness': 'Покупаю от имени компании',
    'guestTrial.payment.sandbox': 'Тестовая среда',
    'guestTrial.payment.subtotal': 'Промежуточный итог',
    'guestTrial.payment.tax': 'Налог',
    'guestTrial.payment.taxInfo': '{tax} рассчитывается с учётом вашего местоположения и данных о продукте.',
    'guestTrial.payment.taxPending': 'Рассчитывается по вашему адресу',
    'guestTrial.payment.terms': 'Условия',
    'guestTrial.payment.thenPerMonth': 'Затем {amount} в месяц',
    'guestTrial.payment.totalDueToday': 'Итого к оплате сегодня',
    'guestTrial.payment.viewDetails': 'Показать детали',
    'guestTrial.renewal': 'Затем тариф Creator за {renewalPrice}/мес., если не отменить',
    'guestTrial.soundHint': 'Включите звук, чтобы услышать разницу',
    'guestTrial.startNow': 'Начать за {price}',
    'guestTrial.success.checking': 'Подтверждаем оплату…',
    'guestTrial.success.claimed': 'Этот платёж уже привязан к аккаунту Rask.',
    'guestTrial.success.createAccount': 'Создать аккаунт',
    'guestTrial.success.email':
      'Зарегистрируйтесь, указав {email}, чтобы привязать оплату. Мы также отправили на этот адрес ссылку для завершения регистрации с любого устройства.',
    'guestTrial.success.noClaim':
      'Мы не нашли вашу оплату на этом устройстве. Откройте эту страницу на том устройстве и в том браузере, где вы платили.',
    'guestTrial.success.openApp': 'Открыть Rask',
    'guestTrial.success.paid': 'Оплата получена — создайте аккаунт, чтобы начать пробный период',
    'guestTrial.success.pending': 'Мы всё ещё подтверждаем оплату. Это может занять минуту.',
    'guestTrial.success.retry': 'Проверить ещё раз',
  },
});
